import { Controller } from 'react-hook-form';
import { FieldError, useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { FiAlertCircle } from 'react-icons/fi';
import { useTheme } from 'styled-components';

import { Container, ReactSelect, ErrorWrapper } from './styles';

type SelectOption = { value: string; label: string };

export type SelectProps = {
  name: string;
  placeholder: string;
  options: Array<SelectOption>;
  required?: boolean;
};

const Select = ({
  name,
  placeholder,
  options,
  required = false,
}: SelectProps) => {
  const { colors } = useTheme();
  const { control, formState } = useFormContext();
  const inputError = formState.errors[name] as FieldError;

  return (
    <Container>
      <Controller
        name={name}
        defaultValue=""
        control={control}
        rules={{ required: required ? 'Campo obrigatório' : false }}
        render={({ field }) => (
          <ReactSelect
            {...field}
            $error={!!inputError}
            options={options}
            placeholder={placeholder}
            maxMenuHeight={250}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            value={options.find((option) => option.value === field.value)}
            onChange={(e: SelectOption) => field.onChange(e.value)}
          />
        )}
      />
      {inputError && (
        <ErrorWrapper>
          <FiAlertCircle color={colors.error[100]} size="0.875rem" />
          <Trans>{inputError.message}</Trans>
        </ErrorWrapper>
      )}
    </Container>
  );
};

export default Select;
